import React, { useId } from 'react';
import { Dropdown } from 'primereact/dropdown';
import FieldShell from './FieldShell';

/**
 * AppSelectField — wraps PrimeReact Dropdown with FieldShell.
 */
const AppSelectField = ({
    label,
    value,
    options,
    onChange,
    optionLabel,
    optionValue,
    placeholder,
    filter = false,
    helperText,
    errorMessage,
    required = false,
    invalid = false,
    disabled = false,
    readOnly = false,
    fluid = true,
    className = '',
    trailing,
    ...rest
}) => {
    const autoId = useId();
    const id = rest.id || autoId;

    const inputCls = [
        'fk-input',
        invalid && 'fk-input--invalid',
        disabled && 'fk-input--disabled',
    ].filter(Boolean).join(' ');

    return (
        <FieldShell
            label={label}
            htmlFor={id}
            required={required}
            helperText={helperText}
            errorMessage={errorMessage}
            invalid={invalid}
            disabled={disabled}
            readOnly={readOnly}
            fluid={fluid}
            className={className}
            trailing={trailing}
        >
            <div className={inputCls}>
                <Dropdown
                    inputId={id}
                    value={value}
                    options={options}
                    onChange={onChange}
                    optionLabel={optionLabel}
                    optionValue={optionValue}
                    placeholder={placeholder}
                    filter={filter}
                    disabled={disabled || readOnly}
                    {...rest}
                />
            </div>
        </FieldShell>
    );
};

export default AppSelectField;
